/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Icon, Intent, Position, Tooltip } from "@blueprintjs/core"
import { useMemo, useState } from "react"
import Shortcode from "src/libs/useful/shortcode"
import { HISTORY_TYPE, IHistoryStep, ILandingFloat, ILandingPrimitive, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import SinglePrimitiveLayer from "./SinglePrimitiveLayer"
import { __ } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { ID } from "src/libs/interfaces/layouts"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../utils/updateSection"
import CheckboxHandler from "./CheckboxHandler"



interface ISingleFloatLayerProps {
    float: ILandingFloat
    sectionId: ID
}
const SingleFloatLayer = ({float, sectionId, ...props}:ISingleFloatLayerProps) : JSX.Element => {
    const currentLanding        = useLandingStore((state: ILandingStore) => state.currentLanding)
    const [isOpen, setIsOpen]   = useState<boolean>( false )
    const primitiveType: string = useMemo(() => {
        if( !!float && !!float.primitives && !!float.primitives[0]) {
            return float.primitives[0].type as string
        }
        return ""
    }, [])

    const onHide = () => {
        const section: ILandingSection = currentLanding.sections.find((s: ILandingSection) => s.id === sectionId)
        const newSect: ILandingSection = {
            ...section,
            floats: section.floats.map(f => {
                if(f.id === float.id) {
                    return {
                        ...f,
                        isHidden: !f.isHidden
                    }
                }
                return f
            }) 
        }
        const historyStep: IHistoryStep = {
            type: HISTORY_TYPE.SECTION,
            data: newSect,
            prevData: JSON.parse( JSON.stringify( section ) ), 
            title: __("Change Float visible.")
        }
        updateSection(newSect, historyStep)
    }
    const onDelete = () => {
        const section: ILandingSection = currentLanding.sections.find((s: ILandingSection) => s.id === sectionId)
        const newSect: ILandingSection = {
            ...section,
            floats: section.floats.filter( f => f.id !== float.id )  
        }
        const historyStep: IHistoryStep = {
            type: HISTORY_TYPE.SECTION,
            data: newSect,
            prevData: JSON.parse( JSON.stringify( section ) ), 
            title: __("Delete Float.")
        }
        updateSection(newSect, historyStep)
    }
    
    const onEdit = () => {
        useLandingStore.setState({ 
            curEditModal: {
                ...float, 
                sectionId: sectionId, 
                currentEditType: SELECT_TYPE.FLOAT,
            }            
        })
    }

    return <>
        <div className="panel-list-button pl-1 pr-1">
            <Icon icon="drag-handle-vertical" className="pl-0 pr-1 pe-surface4 hover " size={13}/>
            <CheckboxHandler 
                onCheck={()=>{}}                 
                type={ SELECT_TYPE.FLOAT } 
                item={ float } 
                sectionId={ sectionId } 
            />
            <img 
                src={ "/assets/img/landing/pin.svg" } 
                alt="" 
                height={8} 
                className="panel-icon pl-3 pr-1 ml-0 " 
                title={__("Float")}
            />
            {
                float?.primitives?.length === 1 
                    ?
                    <img 
                        src={ !!components()[ primitiveType ] ? components()[ primitiveType ].icon  : "/assets/img/landing/" + primitiveType + ".svg" } 
                        alt="" 
                        height={12} 
                        className="panel-icon pr-1 " 
                    />
                    :
                    <Button variant="minimal" onClick={ () => setIsOpen(!isOpen) }>
                        <i className={ isOpen ? "fas fa-chevron-down" : "fas fa-chevron-right" }></i>
                    </Button>
            }
            <Shortcode 
                className="small text-light text-overflow flex-grow-100 px-1" 
                content={ __( float?.primitives?.length === 1 ? float?.primitives[0].type || "Float" : "Float" ) + " <span class='small pe-surface ml-1'><span class='opacity_5'>#" + float.id + "</span></span>" } 
                
            /> 
            <Tooltip
                content={<div className="small">{__("Edit float")}</div>}
                intent={Intent.PRIMARY}
                position={Position.TOP_RIGHT}
                compact
            >
                <Button variant="minimal" onClick={onEdit} > 
                    <Icon icon="edit" size={9} color="#FFFFFF" />
                </Button>
            </Tooltip>
            <Tooltip
                content={<div className="small">{__("Hide | show float")}</div>}
                intent={Intent.PRIMARY}
                position={Position.TOP_RIGHT}
                compact
            >
                <Button variant="minimal" onClick={onHide} >
                    <i className={ !float.isHidden? "far fa-eye" : "far fa-eye-slash" }></i>
                </Button>
            </Tooltip>
            <Tooltip
                content={<div className="small">{__("Remove float")}</div>}
                intent={Intent.PRIMARY}
                position={Position.TOP_RIGHT}
                compact
            >
                <Button variant="minimal" onClick={onDelete} >
                    <i className={ "fas fa-trash" }></i> 
                </Button>
            </Tooltip>
        </div>
        {
            isOpen && float?.primitives?.map(( primitive: ILandingPrimitive ) => {
                return <SinglePrimitiveLayer primitive={primitive} key={primitive.id} />
            })
        }   
    </>
}

export default SingleFloatLayer